import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav a").eq(0).addClass("active")
var swiper = new Swiper(".index-banner .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    loop:true,
    speed:2000,
    autoplay: {
    delay: 3000,
    },
    navigation: {
        nextEl: ".index-banner .swiper-button-next",
        prevEl: ".index-banner .swiper-button-prev",
    },
});
var engineering = new Swiper(".section3 .mySwiper", {
    slidesPerView: "auto",
    spaceBetween: 30,
    breakpoints: {
      320: { //当屏幕宽度大于等于320
        spaceBetween: 0,
      },
      768: { //当屏幕宽度大于等于768 
          spaceBetween: 15,
      },
      1280: { //当屏幕宽度大于等于1280
          spaceBetween: 30,
      }
  },
    pagination: {
      el: ".swiper-control .swiper-pagination",
      clickable: true,
    },
    on: {
      init: function (swiper) {
        let total = this.slides.length;

        if (total < 10) {
          $('.total').text("0" + total);
        } else {
          $('.total').text(total);
        }
        this.emit('transitionEnd');
      },
      transitionEnd: function () {
        //  console.log(this.realIndex);
        var index = this.realIndex + 1;
        if (index < 10) {
          $(".section3 .active").text("0" + index);
        } else {
          $(".section3 .active").text(index);
        }
      }
  },
    navigation: {
      nextEl: ".swiper-control .swiper-button-next",
      prevEl: ".swiper-control .swiper-button-prev",
  },
  });
  $(".section4 .container-news").eq(0).addClass("active")
  $(".news-nav a").eq(0).addClass("active")
  $(".news-nav a").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section4 .container-news").eq(index).addClass("active").siblings().removeClass("active");
})